const config = {
    DOMAIN:'https://api.qingdao.xingyuanzier.com',
    COMPANY_NAME:"青岛市食安检测大数据监管平台"
}
export default config
